module.exports = __webpack_public_path__ + "img/34_31.abb49d60.png";